import WIDGETS from './widgets';

export default {
	name: 'articles_ticket',
	spacing: 0,
	widgets: [{ content: WIDGETS.ARTICLES_MAIN, breakpoints: { xs: 12 }, component_props: { chat_channel_share: true } }],
};
